import { OdataFilters, queryCollection } from "helpers/reqparams";
import { audioExtensions } from "helpers/system";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/fixRouteBids";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter });
    return request(
        `${resource}/getListForOrganizationExcel?${query}`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Заявки на корректировку.xlsx"));
};

const getListForOrganization = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter });
    return request(`${resource}/getListForOrganization${query}`, { method: "GET" }, { countInHeaders: true });
};

const getItemForOrganization = ({ id }: { id: number }) =>
    request(`${resource}/getForOrganization/${id}`, { method: "GET" }).then((data) => {
        data?.files.sort((item: { extension: string }) => (audioExtensions.includes(item.extension) ? 1 : -1));
        return data;
    });

const setStatus = (params: {}) => request(`${resource}/setStatus`, body(params), { noContentAlerts: false });

const getItem = ({ id }: { id: number }) =>
    request(`${resource}/get/${id}`, { method: "GET" }).then((data) => {
        data?.files.sort((item: { extension: string }) => (audioExtensions.includes(item.extension) ? 1 : -1));
        return data;
    });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const uploadFile = (params: {}) => request(`${resource}/uploadFile`, params);

export { index, getItem, setStatus, apply, uploadFile, getListForOrganization, getItemForOrganization, getListExcel };
